import React, { useState, useEffect } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Grid,
    Paper,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Modal,
    AppBar, Toolbar
} from '@mui/material';
import { updateProfile, changePassword, getUserProfile, uploadUserAvatar } from '../services/api';
import { Edit, Delete, Add } from '@mui/icons-material';
import Icon from "../components/Icon";

interface UserProfile {
    id: string;
    email: string;
    image_url: string;
}


const Profile: React.FC = () => {
    const [profile, setProfile] = useState<UserProfile>({
        id: '',
        email: '',
        image_url: '',
    });
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form, setForm] = useState({ name: '', host: '', login: '', password: '' });
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    useEffect(() => {
        fetchUserProfile();
    }, []);

    const fetchUserProfile = async () => {
        try {
            const data = await getUserProfile();
            setProfile(data);
        } catch (error) {
            console.error('Error fetching user profile:', error);
            setError('Failed to load user profile');
        }
    };

    const handleProfileUpdate = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await updateProfile(profile);
            setSuccess('Profile updated successfully');
            setError(null);
        } catch (error) {
            console.error('Error updating profile:', error);
            setError('Failed to update profile');
            setSuccess(null);
        }
    };

    const handlePasswordChange = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await changePassword(oldPassword, newPassword);
            setSuccess('Password changed successfully');
            setError(null);
            setOldPassword('');
            setNewPassword('');
        } catch (error) {
            console.error('Error changing password:', error);
            setError('Failed to change password');
            setSuccess(null);
        }
    };


    return (
        <Box>
            <AppBar position="static">
                <Toolbar className='toolbar'>
                    Профиль пользователя
                </Toolbar>
            </AppBar>
            <Box className='profilePage' sx={{ p: 3 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper className="profileContainer" sx={{ p: 3 }}>
                            <form onSubmit={handleProfileUpdate}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Email"
                                    value={profile.email}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </form>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper className="profileContainer" sx={{ p: 3, mb: 3 }}>
                            <Typography variant="h5" gutterBottom>Изменение пароля</Typography>
                            <form onSubmit={handlePasswordChange}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Старый пароль"
                                    type="password"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Новый пароль"
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <Button type="submit" variant="contained" className='profileBtn' color="primary" sx={{ mt: 2, background: '#503291' }}>
                                    Изменить пароль
                                </Button>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>


            </Box>
        </Box>
    );
};

export default Profile;
